export default "__VITE_ASSET__i9e_t$eM__"